export default "__VITE_ASSET__ed1f8832__"